import { loginSuccess, logout } from '@integration-frontends/common/auth/core/application';
import { DI_CONTAINER, getObservabilityService } from '@integration-frontends/core';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { sendSegmentIdentifyAction } from '@integration-frontends/common/analytics';
import { initSuccess } from '@integration-frontends/common/app';
import {
  IDENTITY_STORE_TOKEN,
  IIdentityStore,
} from '@integration-frontends/common/auth/core/model';
import { push } from 'redux-first-history';
import { persistor } from '../store';
import { environment } from '../../environments/environment';

function* onLoginSuccess(action: ReturnType<typeof loginSuccess>) {
  const identityStore: IIdentityStore = DI_CONTAINER.get(IDENTITY_STORE_TOKEN);
  const { identity } = action.payload;
  yield call(getObservabilityService().sendIdentity, identity, environment?.environment);
  yield put(sendSegmentIdentifyAction({ identity }));
  yield call(identityStore.set, identity);
  persistor.persist();
  yield put(push('/clients'));
}

function* onLogout() {
  yield call(getObservabilityService().stopSessionRecording);
  const identityStore: IIdentityStore = DI_CONTAINER.get(IDENTITY_STORE_TOKEN);
  yield call(identityStore.set, null);
  yield put(initSuccess());
  yield put(push('/getting-started'));
}

export function* authWorkflow() {
  yield all([takeEvery(loginSuccess.type, onLoginSuccess), takeEvery(logout.type, onLogout)]);
}
